module.exports = __webpack_public_path__ + "img/skype.c2c2baf9.svg";